export const ALREADY_EXIST_MESSAGES = {
    email:
        'Din email er allerede registreret og din konto ligger klar til brug. Har du glemt dit kodeord anbefaler vi, at du logger ind med NemID eller kontakter kundeservice.',
    cpr:
        'Dit CPR-nr. er allerede registreret, og din konto ligger klar til brug. Har du glemt dit kodeord, anbefaler vi, at du logger ind med MitID eller kontakter kundeservice.',
};
